import axios from '../../function/axiosInstance'
import extract from '../../function/extract'
import { PAYMENT_SERVICE_BASE_URL } from '../config'

export const updateCustomerDetails = async ({
  vendorId,
  accountId,
  pepperOrganization
}: {
  vendorId: string
  accountId: string
  pepperOrganization: string
}): Promise<ApiResponse> => {
  try {
    const response = await axios.put(
      `${PAYMENT_SERVICE_BASE_URL}/accounts/${accountId}/organization-accounts/${pepperOrganization}`,
      {
        vendor_id: vendorId
      }
    )
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}
